var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { filterEvent } from 'cobrowse-common/interfaces/IMonitoring';
import { isFunction, getCurrentTime } from 'cobrowse-common/modules/utils';
class AgentMonitoring {
    constructor() {
        this.debugLevel = "1";
        this.currentID = null;
        this.latestFlushTimeStamp = 0;
        this.currentBatchTime = null;
        this.currentBatch = [];
        this.monitoringID = null;
        this.channelID = null;
        this.useBeacon = false;
        this.url = '/webinterfaces/integrated/public/log_data.aspx';
        this.configure = (_debugLevel, _monitoringID, _channelID) => {
            this.debugLevel = _debugLevel;
            if (isFunction(window.addEventListener) && window.performance && performance.now) {
                this.monitoringID = _monitoringID;
                this.channelID = _channelID;
            }
        };
        this.syncEvent = (eventType, eventName, eventParams) => {
            if (Monitoring.monitoringID === null) {
                return;
            }
            else if (!Monitoring.filterEvent(eventType)) {
                return;
            }
            if (Monitoring.currentID === null) {
                Monitoring.currentID = Monitoring.generateID();
                Monitoring.currentBatchTime = new Date().getTime();
            }
            const serializedData = {
                ID: `${Monitoring.currentID}_${Monitoring.currentBatch.length}`,
                commandID: eventName,
                commandName: eventName,
                params: eventParams || {},
                eventTime: new Date().getTime()
            };
            serializedData.params.monitoringID = Monitoring.monitoringID;
            serializedData.params.channelID = Monitoring.channelID;
            Monitoring.currentBatch.push(serializedData);
            if (Monitoring.useBeacon || Monitoring.currentBatch.length > 10) {
                Monitoring.flush();
            }
        };
        this.event = (eventType, eventName, eventParams) => __awaiter(this, void 0, void 0, function* () {
            this.syncEvent(eventType, eventName, eventParams);
        });
        this.filterEvent = (currentEventType) => {
            return filterEvent(this.debugLevel, currentEventType);
        };
        this.generateID = () => {
            return Math.floor(Math.random() * 100001);
        };
        this.checkTime = () => {
            const currentStamp = performance.now();
            if (currentStamp - Monitoring.latestFlushTimeStamp < 10000) {
                return;
            }
            Monitoring.flush();
        };
        this.initPolling = () => {
            setInterval(this.checkTime, 3333);
            window.addEventListener('beforeunload', () => {
                if (typeof (Monitoring) !== 'undefined') {
                    Monitoring.flush();
                }
            }, false);
        };
        this.flush = () => {
            if (Monitoring.monitoringID === null) {
                return;
            }
            Monitoring.latestFlushTimeStamp = performance.now();
            if (Monitoring.currentID === null) {
                return;
            }
            else if (Monitoring.currentBatch.length !== 0) {
                const sendTime = getCurrentTime();
                const params = `data=${JSON.stringify(Monitoring.currentBatch)}`
                    + `&firstevent_time=${encodeURIComponent(Monitoring.currentBatchTime)}&sendevent_time=${encodeURIComponent(sendTime)}`;
                Monitoring.currentBatch.forEach(event => {
                    event.time = sendTime - event.eventTime;
                });
                if (Monitoring.useBeacon) {
                    const success = navigator.sendBeacon(Monitoring.url, params);
                    if (!success) {
                        Monitoring.useBeacon = false;
                        Monitoring.initPolling();
                    }
                }
                else {
                    const request = new XMLHttpRequest();
                    request.open('POST', Monitoring.url, true);
                    request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                    request.send(params);
                }
            }
            Monitoring.currentBatch = [];
            Monitoring.currentID = null;
        };
        this.useBeacon = isFunction(navigator.sendBeacon);
        if (window.performance && performance.now) {
            this.latestFlushTimeStamp = performance.now();
            if (!this.useBeacon) {
                this.initPolling();
            }
        }
    }
}
export const Monitoring = new AgentMonitoring();
if (typeof window.Monitoring === 'undefined') {
    window.Monitoring = Monitoring;
}
export const clientError = (message, url) => {
    Monitoring.syncEvent("1", "JavascriptError", { JavascriptException: message, JavascriptURL: url || window.location.href });
};
